import React from 'react';
import { Element } from 'react-scroll';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';

const advantages = [
  {
    title: "Energy Producers",
    description: "Improve reliability with real-time failure prediction for generators, turbines, and hydrogen systems.",
  },
  {
    title: "Utility Companies",
    description: "Use wildfire prediction AI to protect grid assets and optimize vegetation management.",
  },
  {
    title: "IoT Sensor Providers",
    description: "Seamlessly integrate with our platform to deploy AI-enhanced analytics at the data source.",
  },
  {
    title: "Microgrid & Storage Innovators",
    description: "Optimize energy storage logic and load balancing with embedded AI control systems.",
  },
  {
    title: "Regulators & Environmental Agencies",
    description: "Gain transparency through on-edge emissions tracking and compliance reporting.",
  },
  {
    title: "Academic & Research Labs",
    description: "Use our tools for piloting sustainable energy AI models, edge deployments, and data infrastructure.",
  },
]

const Advantage = () => {
  return (
    <>
      <Element
        name="Advantage"
        className="datatalent-section-gap solutions-advantage"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center text-white"
                title = "Energy Ecosystem Integration"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center color-white">Seamless AI + IoT Integration for the Evolving Grid.</p>
            </div>
            {advantages.map((adv) =>
              <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5" key={adv.title}>
                <div className="advantage-card p-4 h-100">
                  <h5 className="mt-3 mb-3 color-white">{adv.title}</h5>
                  <p className="mb-3">{adv.description}</p>
                </div>
            </div>
            )}
          </div>
        </div>
      </Element>
    </>
  )
}

export default Advantage;